<div class="modal-window__header">
  <div class="modal-window__title">
    {{ "department.changedepartment" | translate }}
  </div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<div class="modal-window__subtitle">{{ data.toolId }} - {{ data.modelNumber }}</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="updateDepartment(department.value)"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label">{{ "department.newdepartment" | translate }}</label>
    <mat-select
      #department="ngModel"
      [ngModel]="data.department"
      name="department"
      id="department"
      class="c-user-menu__select c-select c-select--lg">
      <mat-option value="">{{ "department.none" | translate }}</mat-option>
      <mat-option
        [value]="d.name"
        *ngFor="let d of departments">
        {{ d.fullName ? d.name + ": " + d.fullName : d.name }}
      </mat-option>
    </mat-select>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid || isLoading">
      <app-loading-icon *ngIf="isLoading"></app-loading-icon>
      <span *ngIf="!isLoading">{{ "button.save" | translate }}</span>
    </button>
  </div>
</form>
